import {BaseMuWidget} from "../BaseMuWidget";
import {TOPqm} from "./TOPqm";

export class BaseTOI extends BaseMuWidget {

    srcData: any;

    container_click() {
        this.muParent.loadTicket(this.srcData.id, this.srcData);
    }

    setActiveIf(id: any) {
        this.container.classList.toggle('ticket-overview__item--active', id == this.srcData.id);
    }

}